// eslint-disable-next-line camelcase
import ct1_img from '../assets/img_1.png'

export const pointsList = [
  {
    name: '郑州',
    coordinate: [0.77, 0.42],
    halo: {
      show: true
    },
    icon: {
      src: ct1_img,
      width: 30,
      height: 30
    },
    text: {
      show: true
    }
  },
  {
    name: '美国',
    coordinate: [0.23, 0.40],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/us.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '加拿大',
    coordinate: [0.25, 0.30],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/ca.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '英国',
    coordinate: [0.47, 0.27],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/gb.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '德国',
    coordinate: [0.51, 0.32],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/de.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '意大利',
    coordinate: [0.51, 0.37],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/it.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '法国',
    coordinate: [0.49, 0.35],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/fr.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '荷兰',
    coordinate: [0.49, 0.31],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/nl.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '瑞典',
    coordinate: [0.52, 0.22],
    halo: {
      show: true,
      color: '#8378ea'
    },
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/se.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '西班牙',
    coordinate: [0.47, 0.38],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/es.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '墨西哥',
    coordinate: [0.22, 0.49],
    halo: {
      show: true,
      color: '#37a2da'
    },
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/mx.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '日本',
    coordinate: [0.83, 0.41],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/jp.png',
      width: 20,
      height: 20
    },
    length: 100

  },
  {
    name: '澳大利亚',
    coordinate: [0.83, 0.78],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/au.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '巴西',
    coordinate: [0.34, 0.69],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/br.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '印度',
    coordinate: [0.68, 0.50],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/in.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '阿联酋',
    coordinate: [0.62, 0.48],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/ae.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '沙特',
    coordinate: [0.59, 0.46],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/sa.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '新加坡',
    coordinate: [0.74, 0.61],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/sg.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '土耳其',
    coordinate: [0.56, 0.39],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/tr.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '波兰',
    coordinate: [0.53, 0.30],
    icon: {
      src: 'https://528c87e2.oss-cn-beijing.aliyuncs.com/resources/flag/pl.png',
      width: 20,
      height: 20
    }

  },
  {
    name: '俄罗斯',
    coordinate: [0.63, 0.23],
    icon: {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/ru.svg',
      width: 20,
      height: 20
    },

  },
  {
    name: '哈萨克斯坦',
    coordinate: [0.66, 0.32],
    icon: {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/kz.svg',
      width: 20,
      height: 20
    }
  },
  {
    name: '白俄罗斯',
    coordinate: [0.56, 0.29],
    icon: {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/by.svg',
      width: 20,
      height: 20
    }
  },
  {
    name: '乌兹别克斯坦',
    coordinate: [0.63, 0.37],
    icon: {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/uz.svg',
      width: 20,
      height: 20
    }
  },
  {
    name: '亚美尼亚',
    coordinate: [0.59, 0.36],
    icon: {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/am.svg',
      width: 20,
      height: 20
    }
  }
]
export const colors = [
  '#fd27e1',
  '#ff2a04',
  '#f87d18',
  '#ff0',
  '#f5fff1',
  '#a8f807'
]

export function formatter(number, n) {

  const numArr = number.toFixed(n).toString().split('.')
  const numbers = numArr[0].split('').reverse()
  const segs = []

  while (numbers.length) segs.push(numbers.splice(0, 3).join(''))
  if (numArr[1]) {
    return segs.join(',').split('').reverse().join('') + '.' + numArr[1]
  }
  return segs.join(',').split('').reverse().join('')
}

export const totalTitle = [
  {name: 'oem', title: '孵化机构', color: '#f46827', width: 300, other: '海外仓数量'},
  {name: 'user', title: '用户数量', color: '#4d99fc', width: 300, other: '企业用户数量'},
  {name: 'market', title: '店铺数量', color: '#40faee', width: 300, other: '海外仓面积(㎡)'},
  {name: 'order', title: '订单总数', color: '#4d99fc', width: 300, other: '处理订单总数'},
  {name: 'amount', title: '订单总金额', color: '#f46827', width: 400, other: '服务订单总金额'}
]
